import * as R from 'ramda'

export const updateFilter = (name, value, filters) => {
  const filterIndex = R.findIndex(R.propEq('name', name))(filters)
  if (filterIndex > -1) {
    return R.adjust(filterIndex, x => ({ ...x, value }))(filters)
  }
  return [...filters, { name, value }]
}
